/*
 * Lemonade Training Oy, copy rights, all right reserved.
 *
 * Coach roster copy for a member behind on payment. State only, never dates
 * or card details. No em dashes anywhere here.
 */

export const PAYMENT_ISSUE_BADGE = "Payment issue";

export const PAYMENT_ISSUE_GRACE = "grace period";

export const PAYMENT_ISSUE_PAUSED = "access paused";

export const PAYMENT_ISSUES_ONLY_FILTER = "Payment issues only";

export const PAYMENT_ISSUES_UNAVAILABLE = "Payment issue flags couldn't be loaded right now.";
